import {createSelector} from 'reselect'
import {UserMeResponse} from '../../infra/api/types'
import {MeSchema} from '../../infra/redux/api/schemata'
import * as apiSelectors from '../../infra/redux/api/selectors'

export const isAuthorized = createSelector(
  apiSelectors.getOne(MeSchema),
  (me: UserMeResponse): boolean => !!me,
)
